
function addCommas(x) {
	var number = removeCommas(x)
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

function removeCommas(x) {
	return x ? parseFloat(x.toString().replace(/[,$]/g, '')) : 0
}

function setupCalculator(calculator) {

	const calculatorSalary = calculator.querySelector('#base-salary')
	const calculatorTarget = calculator.querySelector('#target-bonus')
	const calculatorPerformance = calculator.querySelector('#business-performance')
	const calculatorPercentage = calculator.querySelector('.calculator-percentage')
	const calculatorPercentageHalf = calculator.querySelector('.calculator-percentage__half')
	const calculatorResults = calculator.querySelector('.calculator-results')
	const calculatorBasePercentage = calculator.querySelector('.calculator-base-percentage')

	const calculatorImpact = calculator.querySelector('input[name="impact-rating"]:checked')
	const calculatorDifferential = calculator.querySelector('.bonus-differential')
	const impactRating = calculator.querySelectorAll('.impact-rating__cont .impact-rating__option')
	const bonusDiff = calculator.querySelectorAll('.bonus-differential .impact-rating__option')
	const impactPercentageCont = calculator.querySelector('.impact-percentage')
	var impactPercentage = '0';
	var salaryPercentage = '0';
	
	function update() {
		const amount = calculatorSalary.value * 1
		const salary = removeCommas(calculatorSalary.value) * 1
		const target = calculatorTarget.value * 1
		const percent = calculatorPerformance.value * 1
		const percentHalf = (calculatorPerformance.value * 1) / 2
		const impact = calculator.querySelector('input[name="impact-rating"]:checked').value * 1
		const differential = calculator.querySelector('input[name="bonus-diff"]:checked').value * 1

		var result = ((salary/100) * target) * (percent/100)

		if (impact !== 1) {
			calculatorDifferential.classList.add('hide')
			result = (result * impact)
			salaryPercentage = (target/100 * impact) * percent
		} else {
			calculatorDifferential.classList.remove('hide')
			result = (result * differential)
			salaryPercentage = (target/100 * differential) * percent
		}

		calculatorPercentage.innerHTML = `${calculatorPerformance.value}%`
		calculatorPercentageHalf.innerHTML = `${percentHalf}%`
		calculatorResults.innerHTML = addCommas(Math.round(result))
		calculatorBasePercentage.innerHTML = (salaryPercentage === 0) ? 'No Award' : `${Math.trunc(salaryPercentage)}%`
	}

	calculator.addEventListener('keyup', update)
	calculator.addEventListener('change', update)
	calculator.addEventListener('input', update)

	calculatorTarget.addEventListener('input', () => {
		if (this.value > 100) this.value = '100'
	})

	calculatorSalary.addEventListener('input', () => {
		this.value = addCommas(this.value)
	})

	calculator.addEventListener('keyup', update)

	// Impact rating
	impactRating.forEach(el =>  {
		el.addEventListener('click', () => {
			impactRating.forEach(el =>  {
				el.classList.remove('active')
			})
			var input = el.querySelector('input');
			impactPercentage = parseInt(input.getAttribute('data-value'));
			impactPercentageCont.innerHTML = `${100 + impactPercentage}%`
			el.classList.add('active')
		})
	})

	// Impact rating
	bonusDiff.forEach(el =>  {
		el.addEventListener('click', () => {
			bonusDiff.forEach(el =>  {
				el.classList.remove('active')
			})
			var input = el.querySelector('input');
			impactPercentage = parseInt(input.getAttribute('data-value'));
			impactPercentageCont.innerHTML = `${100 + impactPercentage}%`
			el.classList.add('active')
		})
	})

}


[...document.querySelectorAll('.calculator')].map(setupCalculator)
